import { defineComponent as _defineComponent } from 'vue'
import {cityData} from './../assets/cityData';
import {ref} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CityPicker',
  props: {
    modelValue: {
        type: Boolean,
        default: false,
    },
},
  emits: ['update:modelValue', 'confirm'],
  setup(__props, { expose, emit: emits }) {
  expose();

const props = __props





const close = () => {
    emits('update:modelValue', false);
};

const confirm = (data: any) => {
    emits('update:modelValue', false);
    emits('confirm', data);
};

const __returned__ = { props, emits, close, confirm, cityData, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})